module.exports = __webpack_public_path__ + "img/meeting.d9b48300.jpg";